let UTILS = require("../libs/utils.js");
var v7747;
var v7748;
module.exports = {
  id: "trai",
  name: "Traitor",
  alias: "trai",
  lives: 1,
  teams: true,
  noDeadChat: true,
  noKillFeed: true,
  teamOptions: ["Innocent", "Traitor"],
  teamColors: ["#37ad47", "#d13838"],
  showTeam: true,
  noRegen: true,
  fakeNames: true,
  noScoreK: true,
  dmgTeam: true,
  winCondition: function (game) {
    var vLN01233 = 0;
    var vLN01234 = 0;
    for (var vLN01235 = 0; vLN01235 < game.players.list.length; ++vLN01235) {
      if (game.players.list[vLN01235].lives > 0) {
        var v7749 = game.players.list[vLN01235].lives;
        if (game.players.list[vLN01235].team == 1) {
          vLN01233 += v7749;
        } else {
          vLN01234 += v7749;
        }
      }
    }
    if (vLN01233 > vLN01234) {
      return 1;
    } else {
      return 2;
    }
  },
  condition: [function (game) {
    var vLN01236 = 0;
    var vLN01237 = 0;
    for (var vLN01238 = 0; vLN01238 < game.players.list.length; ++vLN01238) {
      if (game.players.list[vLN01238].lives > 0 && game.players.list[vLN01238].active) {
        if (game.players.list[vLN01238].team == 1) {
          vLN01236++;
        } else {
          vLN01237++;
        }
      }
    }
    return vLN01236 >= 1 && vLN01237 >= 1;
  }],
  waitTimers: [{
    time: 15000,
    msg: "picking traitors in ",
    trigger: function (p9219) {
      p9219.pickTraitors();
    }
  }],
  onKill: function (p9220, p9221, p9222) {
    if (!p9220.waitTimers) {
      p9220.AI.spawn(null, 0, p9222.name + "'s Ghost", p9222.x, p9222.y, p9222.z);
    }
  },
  noReward: true,
  minPlayers: 3
};